import {
  Component,
  OnInit,
  ViewChild,
  ViewChildren,
  QueryList,
  HostListener
} from '@angular/core';
import {
  GlobalSettings
} from 'src/app/global.settings';
import {
  CommonService
} from 'src/app/common.service';
import Utils from 'src/app/utils';
import {
  TreeDataService
} from 'src/app/tree-data.service';
import {
  AutoCompleteComponent
} from 'src/app/common/auto-complete/auto-complete.component';
import {
  SharedService
} from 'src/app/shared.service';
import {
  RecaptchaComponent
} from 'ng-recaptcha';
import {
  Observable
} from 'rxjs';
import {
  HttpClient
} from '@angular/common/http';
import {
  TreeSearchComponent
} from 'src/app/common/tree-search/tree-search.component';
import { IMyDpOptions } from 'mydatepicker';

@Component({
  selector: 'app-front-facing-public-review',
  templateUrl: './front-facing-public-review.component.html',
  styleUrls: ['./front-facing-public-review.component.scss']
})
export class FrontFacingPublicReviewComponent implements OnInit {
  publicReviewList = []; // holds list of Public Review
  reviewListLoaded = false; // holds flag to display loader while loading Public Review list
  uniqueId = ''; // holds unique ID of Public Review object
  title = ''; // holds display-text property of Public Review object
  autoCompleteTitle = 'Review'; // holds title of Public Review list drop-down
  nodeTypeList = []; // holds list of nodetypes of selected Public Review
  selectedReview: any; // holds selected Public Review
  orgId = ''; // holds current organization ID
  nodesLoaded = false; // holds flag to display loader while loading tree-nodes & filtering them
  filteredNodeList = []; // holds list of nodes, filtered by configuration filter-level
  worker: any; // holds worker instance
  treeData: any; // holds tree-hierarchy of selected Public Review
  loadingNodes = false; // holds flag to display loader while loading children of selected filter-level node
  filterCriteriaList = []; // holds list of filter criteria (for worker utilization purpose)
  selectedNode: any; // holds the node selected on LAST filter-level
  configFilterLevel = []; // holds array of filter-levels (as per configuration)
  selectedFilter: any; // holds list of selected filters (level & node_type_id) to filter nodes from tree
  selectedFilterLevelNode: any; // holds the node selected on filter-level
  configFeedbackLevel = []; // holds array of feedback levels (as per configuration)
  frontFaceParams = ''; // holds front-facing parameters to call APIs
  userInfoParams = []; // holds list of parameters to get user information
  finalObjToSubmit = {
    user_metadata: [],
    comments: [],
    user_id: ''
  }; // holds object to submit Public Review
  isSubmitting = false; // holds flag to display loader while submitting feedback
  siteKey = '6Le7tYsUAAAAACM8LIHTr9dWMHQlxUIKVqTPHGLV'; // holds site key for captcha
  captchaValidate = false; // holds flag to validate captcha
  textJsonData: any;
  skipCaptchaValidation = false; // holds boolean value to skip captcha validation
  isRegisteredUser = false;
  documentId = ''; // holds the taxonomy ID of the selected PR
  currentConfigObj: any; // holds the object of currently selected PR configuration
  isFilterApplied = false; // holds the boolean value to indicate if the search-filter is applied
  searchResultList = []; // holds the list of search results
  disableSelection = false; // holds boolean to determine disablity on filters on search
  isReset = false; // holds flag value to reset search params
  isFirstTime = true; // holds flag to indicate if the search is being performed for the first time
  isSearching = false; // holds flag to show loader while searching
  initialiseSearch = true; // holds flag to initialise search component
  domain = GlobalSettings.HOSTNAME;

  public myDatePickerOptionsStartDate: IMyDpOptions = {
    dateFormat: 'yyyy-mm-dd',
    inline: false,
    editableDateField: false,
    openSelectorOnInputClick: true,
  };

  @ViewChild('autoComplete_review') autocompleteReview: AutoCompleteComponent;
  @ViewChild('autoComplete_node1') autocompleteNodeL1: AutoCompleteComponent;
  @ViewChild('autoComplete_node2') autocompleteNodeL2: AutoCompleteComponent;
  @ViewChildren('autoComplete_info') autoCompleteInfo: QueryList<AutoCompleteComponent>;
  @ViewChild('captchaElem') captchaElem: RecaptchaComponent;
  @ViewChild('treeSearch') treeSearch: TreeSearchComponent;

  constructor(
    private service: CommonService,
    private treeService: TreeDataService,
    private sharedService: SharedService,
    private http: HttpClient) {
    if (document.location.hostname.indexOf('standards.ed.sc.gov') !== -1 ||
      document.location.hostname.indexOf('acmt-preprod.learningmate.com') !== -1 ||
      document.location.hostname.indexOf('aks.gcpsk12.org') !== -1 ||
      document.location.hostname.indexOf('standards.isbe.net') !== -1 ||
      document.location.hostname.indexOf('www.learningmate.co') !== -1 ||
      document.location.hostname.indexOf('frostplatform.com') !== -1 ||
      GlobalSettings.COMMON_DOMAIN === 'https://www.learningmate.co/' ||
      GlobalSettings.COMMON_DOMAIN === 'https://frostplatform.com/' ||
      GlobalSettings.COMMON_DOMAIN === 'https://unifiedfrost-dev.learningmate.co/' ||
      GlobalSettings.COMMON_DOMAIN === 'https://unifiedfrost-devsupport.learningmate.co/' ||
      GlobalSettings.COMMON_DOMAIN === 'https://mhu03-dev-frost.learningmate.com/' ||
      GlobalSettings.COMMON_DOMAIN === 'https://unifiedfrost-qa.learningmate.co/' ||
      GlobalSettings.COMMON_DOMAIN === 'https://unifiedfrost-stage.learningmate.co/' ||
      GlobalSettings.COMMON_DOMAIN === 'https://unifiedfrost-pt.learningmate.co/') {
      this.siteKey = GlobalSettings.RECAPTCHA_KEY;
    } else {
      this.siteKey = GlobalSettings.RECAPTCHA_KEY_OTHER_SITES;
    }

    const orgCode = localStorage.getItem('orgDetails') ? JSON.parse(localStorage.getItem('orgDetails')).orgCode : '';
    this.skipCaptchaValidation = GlobalSettings.SKIP_RECAPTCHA_VALIDATION_TENANTS.indexOf(orgCode) > -1;

    this.sharedService.orgDetails.subscribe((data: any) => {
      if (data && data.organization_id) {
        this.orgId = data.organization_id;
        this.frontFaceParams = 'organization_id=' + this.orgId + '&front_facing=true';
        this.getPublicReviewList();
      }
    });
  }

  ngOnInit() {
    this.verifyUser();
    this.getTextData();
  }

  public getJSON(): Observable<any> {
    return this.http.get('./assets/json/publicReviewData.json');
  }


  getTextData() {
    this.textJsonData = null;
    this.getJSON().subscribe(data => {
      this.textJsonData = data;
      console.log('JSON data', this.textJsonData);
    });
  }

  verifyUser() {
    this.isRegisteredUser = false;
    let ssoUser = Utils.getCookie('SSOUser');
    if (ssoUser && ssoUser !== "null") {
      this.isRegisteredUser = true;
    }
  }


  // FUNCTION to get list of Public Reviews with configuration

  getPublicReviewList() {
    this.reviewListLoaded = false;
    const url = GlobalSettings.PROJECT_LIST + '?project_type=3&return_order=1&' + this.frontFaceParams;
    this.service.getUserServiceDataWithoutTocken(url).then((res: any) => {
      if (res) {
        const firstFilteredList = res.projects.filter((item: any) => item.config_id && item.public_review_status === 2);
        if (this.isRegisteredUser) {
          this.publicReviewList = firstFilteredList.filter((pr: any) => pr.user_type.authenticated);
        } else {
          this.publicReviewList = firstFilteredList.filter((pr: any) => pr.user_type.anonymous);
        }
        this.uniqueId = 'project_id';
        this.title = 'project_name';
      }
      this.reviewListLoaded = true;
    }).catch(ex => {
      this.reviewListLoaded = true;
    });
  }


  // FUNCTION to perform next steps after selecting / deselecting a Public Review from drop-down

  onPublicReviewSelected(data) {
    if (this.autocompleteNodeL1) {
      this.autocompleteNodeL1.clearSelection();
    }
    this.selectedFilterLevelNode = null;
    this.selectedNode = null;
    this.finalObjToSubmit = {
      user_metadata: [],
      comments: [],
      user_id: ''
    };
    this.selectedReview = data;
    if (data) {
      this.documentId = data[this.uniqueId];
      this.getConfigDetails(data.config_id);
      this.loadNodeTypes(this.documentId);
    }
  }


  // FUNCTION to load the list of nodetypes of selected Public Review

  loadNodeTypes(taxonomyId) {
    const viewType = 'node_type';
    this.nodeTypeList = [];
    const url = GlobalSettings.TAXONOMY_NODE_TYPE_DETAILS + '/' + taxonomyId + '/2/' + viewType + '?return_order=1&' + this.frontFaceParams;

    this.service.getUserServiceDataWithoutTocken(url).then((res: any) => {
      if (res && res.nodeTypes) {
        res.defaultNodeTypesOrder.forEach(nodeType => {
          const elem = res.nodeTypes.find(item => item.node_type_id === nodeType);
          this.nodeTypeList.push(elem);
        });
      }
    });

  }


  // FUNCTION to load the tree-hierarchy of selected Public Review

  loadTreeData(id) {
    this.nodesLoaded = false;
    if (id) {
      this.treeData = null;
      const url = GlobalSettings.GET_MAPPED_NODES_ALL + '/' + id + '?' + this.frontFaceParams;
      this.treeService.getTreeData(url, true, Utils.EXPAND_LEVEL, false).then((response: any) => {
        const res = response.parsedTreeNodes;
        if (res && res.children) {
          this.treeData = res.children;
          this.createFilter(0);
        }
      }).catch(ex => {
        console.log('list of taxonomies ex ', ex);
      });
    }
  }


  // FUNCTION to get configuration details (Public Review specific)

  getConfigDetails(configId) {
    this.configFeedbackLevel = [];
    this.configFilterLevel = [];
    const url = GlobalSettings.PR_CONFIG_DETAILS_URL + configId + '?' + this.frontFaceParams;

    this.service.getUserServiceDataWithoutTocken(url, true).then((response: any) => {
      if (response) {
        this.currentConfigObj = response.value;

        this.currentConfigObj.part_of_taxonomy_to_display['selected_nodes'].forEach(item => {
          if (item.checked && item.view_type === 1) {
            this.configFilterLevel.push(item);
          }

          if (item.checked && item.view_type === 2) {
            this.configFeedbackLevel.push(item.level);
          }
        });
        this.userInfoParams = this.currentConfigObj.metadata ? this.currentConfigObj.metadata : [];
        this.userInfoParams.forEach((info: any) => {
          info.user_metadata_value = '';
        });
        this.loadTreeData(this.documentId);
      }
    });
  }


  // FUNCTION to perform next steps after selected filter level node (as per configuration)

  onFilterLevelNodeSelected(data, index) {
    if ((index + 1) !== this.configFilterLevel.length) {
      this.getNextlevelNodes(data);
    } else {
      this.onNodeSelected(data);
    }
  }


  // FUNCTION to load next level nodes of selected filter-level node

  getNextlevelNodes(data) {
    this.loadingNodes = true;
    if (this.autocompleteNodeL2) {
      this.autocompleteNodeL2.clearSelection();
    }
    this.selectedNode = null;
    this.selectedFilterLevelNode = data;
    this.createFilter(1);
    this.loadingNodes = false;
  }


  // FUNCTION to select last filter-level node

  onNodeSelected(node) {
    this.selectedNode = node;
    if (this.treeSearch) {
      this.treeSearch.getFilterData(this.selectedNode);
    }
  }


  // FUNCTION to create filter-list for filtering nodes

  createFilter(index) {
    this.filterCriteriaList = [{
      display_name: 'Level',
      internal_name: 'level',
      metadata_id: 'level_1234',
      name: 'Level',
      propName: 'level'
    }, {
      display_name: 'Node Type',
      internal_name: 'node_type_id',
      metadata_id: 'nodeType_1234',
      name: 'Node Type',
      propName: 'node_type_id'
    }];
    this.selectedFilter = [{
      label: this.configFilterLevel[index].level,
      colName: 'level'
    },
    {
      label: this.configFilterLevel[index].node_type_id,
      colName: 'node_type_id'
    }
    ];
    this.callGetFilterResult(index);
  }


  // FUNCTION to get list of filtered nodes (based on configuration) from tree-hierarchy

  callGetFilterResult(index) {
    this.filteredNodeList[index] = [];
    if (typeof Worker !== 'undefined') {
      this.worker = new Worker(new URL('../../treeService.worker', import.meta.url), {
        type: 'module'
      });
    }
    if (this.worker) {
      this.worker.onmessage = ({
        data
      }) => {
        if (data) {
          this.treeData = data.treeData;
          this.filteredNodeList[index] = data.filterResult;
          this.filteredNodeList[index].forEach(node => {
            node['display_name'] = Utils.extractContentFromHtml((node.human_coding_scheme_html ? node.human_coding_scheme_html : node.human_coding_scheme) + ' ' +
              (node.full_statement_html ? node.full_statement_html : node.full_statement));
          });
          setTimeout(() => {
            this.nodesLoaded = true;
          }, 500);
        }
      };
      this.worker.postMessage({
        data: this.treeData,
        location: 'tree-search',
        parameters: {
          filterCriteriaList: this.filterCriteriaList,
          search: false,
          searchText: '',
          isReset: false,
          selectedFilterList: this.selectedFilter,
          getFilterResult: true,
          dataForGetFilterResult: index === 0 ? this.treeData : this.selectedFilterLevelNode.children,
          searchResultList: [],
          filterResult: [],
          filterObj: []
        }
      });
    }
  }


  // FUNCTION to save user-detail inputs

  saveDetails() {
    this.userInfoParams.forEach(param => {
      this.finalObjToSubmit['user_metadata'].push({
        user_metadata_id: param.user_metadata_id,
        user_metadata_value: (param.user_metadata_value.toLowerCase() === 'none' ||
          param.user_metadata_value.toLowerCase() === 'not applicable') ? '' : param.user_metadata_value
      });
    });

    this.submitReview();

    if (document.getElementById('cancel-modal-btn-userDetailPR')) {
      document.getElementById('cancel-modal-btn-userDetailPR').click();
    }

  }


  // FUNCTION to clear user inputs

  clearInputs() {
    this.userInfoParams.forEach(info => {
      info.user_metadata_value = '';
    });
    if (this.autoCompleteInfo) {
      const userInfo = this.autoCompleteInfo.toArray();
      userInfo.forEach(info => {
        info.clearSelection();
      });
    }
    this.captchaValidate = false;
    if (this.captchaElem) {
      this.captchaElem.reset();
    }
  }


  // FUNCTION to like a node

  likeNode(node) {
    node.liked = !node.liked;
    this.saveFeedback(node);
  }


  // FUNCTION to save user feedback (like & comment) for each node

  saveFeedback(node) {
    const index = this.finalObjToSubmit['comments'].findIndex(item => item.thread_source_id === node.id);
    if (index > -1) {
      const obj = this.finalObjToSubmit['comments'][index];
      obj.is_like = node.liked ? 1 : 0;
      obj.comment = node.comment && node.comment.trim() !== '' ? node.comment : '';
      obj.updated_at = this.getTimeStamp();
    } else {
      this.finalObjToSubmit['comments'].push(this.createFeedbackObj(node));
    }
    const optimizedList = this.finalObjToSubmit.comments.filter(item => item.is_like || item.comment);
    this.finalObjToSubmit.comments = optimizedList;
  }


  // FUNCTION to create new object for feedback

  createFeedbackObj(node) {
    const obj = {
      thread_source_id: node.id,
      status: 1,
      comment: node.comment && node.comment.trim() !== '' ? node.comment : '',
      thread_source_type: 1,
      is_like: node.liked ? 1 : 0,
      updated_at: this.getTimeStamp()
    };

    return obj;
  }

  getTimeStamp() {
    const dt = new Date();
    const date = dt.getFullYear() + '-' + (dt.getMonth() + 1) + '-' + dt.getDate();
    const time = dt.getHours() + ':' + dt.getMinutes() + ':' + dt.getSeconds();
    return (date + ' ' + time);
  }

  // FUNCTION to submit Public Review

  submitReview() {
    this.isSubmitting = true;
    const url = GlobalSettings.SUBMIT_REVIEW_FRONT_FACE_URL + '?' + this.frontFaceParams;
    const body = this.finalObjToSubmit;
    body['user_id'] = localStorage.getItem('user_id') ? localStorage.getItem('user_id') : '';
    this.service.registerService(url, body).then((res: any) => {
      this.sharedService.sucessEvent.next({
        type: 'success',
        customMsg: 'Thank you, your feedback has been submitted successfully.'
      });
      if (this.autocompleteReview) {
        this.autocompleteReview.clearSelection();
      }
      this.onPublicReviewSelected(undefined);
      this.finalObjToSubmit.comments = [];
      this.finalObjToSubmit.user_metadata = [];
      this.currentConfigObj = null;
      this.isSubmitting = false;
    });
  }


  // function to close dropdown on outside click

  onClickedOutside(e, type, index?) {
    switch (type) {
      case 'review':
        if (this.autocompleteReview) {
          this.autocompleteReview.openPanel(false);
        }
        break;
      case 'node1':
        if (this.autocompleteNodeL1) {
          this.autocompleteNodeL1.openPanel(false);
        }
        break;
      case 'node2':
        if (this.autocompleteNodeL2) {
          this.autocompleteNodeL2.openPanel(false);
        }
        break;
      case 'info':
        if (this.autoCompleteInfo) {
          const targets = this.autoCompleteInfo.toArray();
          for (let i = 0; i < targets.length; i++) {
            if (i === index) {
              targets[i].openPanel(false);
            }

          }
        }
        break;
      default:
    }
  }


  //  FUNCTION to resolve captcha

  resolved(captchaResponse: string) {
    console.log(`Resolved captcha with response ${captchaResponse}:`);
    this.captchaValidate = true;
  }


  // FUNCTION to check user-input validation

  checkInput() {
    const validInput = this.userInfoParams && this.userInfoParams.every(param => param.user_metadata_value !== '');
    return validInput;
  }

  // FUNCTION to select value from user-info drop-downs

  onUserInfoSelected(selectedOption, metadata) {
    metadata.user_metadata_value = selectedOption.name;
  }


  // FUNCTION to set loader
  setLoaderEvent(val) {
    this.isFirstTime = val['isFirstTime'];
    this.isSearching = val['isLoading'];
    this.initialiseSearch = false;
  }

  // FUNCTION to get search result and update view accordingly
  captureSearchEvent(event) {
    this.isFilterApplied = event.isFilterApplied;
    this.searchResultList = event.filterData;
    this.selectedNode = event.treeData;
    this.disableSelection = true;
    if (this.isFilterApplied) {
      this.isReset = false;
    }
    if (!this.isFilterApplied && !this.isReset) {
      this.isReset = true;
    }
  }

  // Textarea height resizing
  autoGrow(elementId) {
    const textArea = document.getElementById(elementId);
    setTimeout(() => {
      if (textArea) {
        textArea.style.cssText = 'height:auto;overflow:hidden;';
        textArea.style.cssText = 'height:' + (textArea.scrollHeight + 2) + 'px';
      }
    }, 0);
  }

  // FUNCTION to set start and end date of Public review

  onCustomDateChanged(evt, index) {
    const date = evt.formatted;
    this.userInfoParams[index].user_metadata_value = date;
  }

  // FUNCTION to check if the the current input is a number
  isNumber(evt) {
    Utils.isNumber(evt);
  }

  @HostListener('window:click', ['$event'])
  clickout(event) {
    if(!event.target.closest('.dropdown')) {
      this.sharedService.autoCompleteEvent.next({
        id : 'test',
        val : false
      });
    } 
  }

}
